/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgAzure = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        d="M21.403 19.178 16.3 3.87a1.276 1.276 0 0 0-1.276-.867H8.977a1.276 1.276 0 0 0-1.212.867L2.598 19.18a1.275 1.275 0 0 0 1.276 1.683h3.738a1.275 1.275 0 0 0 1.199-.867l.778-2.27 3.827 2.895c.223.161.491.246.766.242h5.97a1.277 1.277 0 0 0 1.25-1.684zm-7.17.842a.408.408 0 0 1-.255-.089L6.77 14.586l-.115-.09h3.827l.102-.268 1.276-3.227 2.858 8.458a.433.433 0 0 1-.485.561zm5.958 0h-4.746a1.28 1.28 0 0 0 0-.842L10.278 3.87h4.746a.434.434 0 0 1 .408.294L20.6 19.472a.435.435 0 0 1-.408.548z"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgAzure as Azure };
